import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function Transformation() {
  return <section className="w-full max-w-5xl mx-auto px-4 md:px-8" data-id="element-367">
      <FadeIn className="text-center mb-12" data-id="element-368">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-369">
          The Transformation
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream" data-id="element-370">
          This Is The Difference A System Makes.
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-371">
        <FadeIn direction="left" className="h-full" data-id="element-372">
          <div className="bg-[#2a1212] border border-red-900/30 rounded-2xl p-6 md:p-8 h-full" data-id="element-373">
            <h3 className="font-playfair text-xl text-red-400/80 mb-6" data-id="element-374">
              Before Resin Without Errors™
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-375">
              <li className="flex items-start gap-3" data-id="element-376">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-377">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-378">
                  Sticky, tacky resin you have to throw away
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-379">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-380">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-381">
                  Bubbles ruining every pour
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-382">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-383">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-384">
                  Hours on YouTube, still confused
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-385">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-386">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-387">
                  Wasted money on supplies that don't work
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-388">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-389">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-390">
                  Feeling like everyone else can do it but you
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-391">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-392">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-393">
                  Nothing you'd be proud to sell
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>

        <FadeIn direction="right" className="h-full" data-id="element-394">
          <div className="bg-[#122a14] border border-amber/20 rounded-2xl p-6 md:p-8 h-full" data-id="element-395">
            <h3 className="font-playfair text-xl text-amber mb-6" data-id="element-396">
              After Resin Without Errors™
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-397">
              <li className="flex items-start gap-3" data-id="element-398">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-399">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-400">
                  Clean, professional pieces every pour
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-401">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-402">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-403">
                  Zero bubbles with the Anti-Bubble Protocol™
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-404">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-405">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-406">
                  A clear system that tells you exactly what to do
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-407">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-408">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-409">
                  Stop wasting supplies — buy only what you need
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-410">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-411">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-412">
                  Confidence at your workbench for the first time
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-413">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-414">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-415">
                  Your first sell-ready piece by Day 6
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}